import preval from "preval.macro";
import config from "../config.js";

export const PUSHER_APP_KEY = config.PUSHER_APP_KEY;

export const PAYMENT_TIMEOUT = config.PAYMENT_TIMEOUT;
export const WEBSOCKET_HOST = config.WEBSOCKET_HOST;
export const DIA_API_EXCHANGE_NAME = config.DIA_API_EXCHANGE_NAME;
export const FRONTEND_DOMAIN = config.FRONTEND_DOMAIN;
export const BACKEND_DOMAIN = config.BACKEND_DOMAIN;
export const RESOURCES_DOMAIN =
  config.RESOURCES_DOMAIN ?? config.BACKEND_DOMAIN + "/storage";
export const FRONTEND_API_DOMAIN =
  config.FRONTEND_API_DOMAIN ?? config.FRONTEND_DOMAIN + "/api/v1";
export const BACKEND_API_DOMAIN =
  config.BACKEND_API_DOMAIN ?? config.BACKEND_DOMAIN + "/api/v1";
export const API_ACCESS_TOKEN = config.API_ACCESS_TOKEN;
export const WIDGET_RENDER_TARGET_ID = config.WIDGET_RENDER_TARGET_ID;
export const PRIVACY_POLICY_URL = config.PRIVACY_POLICY_URL;
export const LANGUAGES = config.LANGUAGES;
export const DEFAULT_PATH = config.DEFAULT_PATH ?? import.meta.env.VITE_DEFAULT_PATH;
export const SHOW_BUILD_DATE = config.SHOW_BUILD_DATE ?? false;
export const NUMBER_FORMAT_LOCALE: string | string[] = ["uk-UA"];
export const HTTP_POST_REQUEST_DOMAIN = config.HTTP_POST_REQUEST_DOMAIN;
export const RUNNER_VERSION = 1;

export const BUILD_DATE = preval`
  const moment = require('moment');
  module.exports = moment().format('YYYY-MM-DD HH:mm:ss');
`;
export const DEFAULT_LANGUAGE = LANGUAGES[0];
export const IS_IOS_DEVICE = CSS.supports("(-webkit-touch-callout: none)");
export const IOS_DUMMY_INPUT = "ios_dummy_input";
export const getCsrfToken: () => string = () =>
  window.top?.document.querySelector(
    'meta[name="csrf-token"]'
    //@ts-ignore
  )?.content;
export const refreshCsrfToken = async () => {
  const resp = await fetch(FRONTEND_DOMAIN + "/auth/web/refresh-token", {
    method: "GET",
  });
  const { token } = await resp.json();
  const csrf = window.top?.document.querySelector('meta[name="csrf-token"]');
  //@ts-ignore
  if (csrf) csrf.content = token;
  return token;
};

export const _window = window.top ?? window;
export const isBackend = window.location.href.includes(BACKEND_DOMAIN);

const node = window.top?.document.querySelector(
  "#widget-backend-params > input"
) as HTMLInputElement | null;
type BackendParams = {
  lang: string;
  path: string;
  productId: string;
  withCart?: boolean;
  otpResendPath?: string;
  websocketModule?: string;
  externalPayment?: boolean;
  localStoragePath?: string;
  buyInsurancePath?: string;
  saveInsurancePath?: string;
  calculateInsurancePath?: string;
  externalPaymentSendPath?: string;
  productInfoRequest?: {
    options?: any;
    params?: any,
    url: string
  };
};

export const BACKEND_PARAMS: BackendParams = node?.value
  ? JSON.parse(window.atob(node.value))
  : {
      lang: DEFAULT_LANGUAGE,
      path: DEFAULT_PATH,
      productId: "8",
      withCart: true
    };

export const STORAGE_PATH_NAME = BACKEND_PARAMS.localStoragePath ?? 'widget';
if(BACKEND_PARAMS.withCart === undefined) BACKEND_PARAMS.withCart = true;